<template lang="html">
    <v-card style="border-radius: 5px;" :color="`${color}`">
      <v-layout align-center>
      <v-icon v-if="icon" class="dataFieldIcon" :color="textcolor">{{icon}}</v-icon>
      <input v-if="!textarea"
      :readonly="readonly" :value="value" class="work_package-data-field"
      @change="$emit('changeValue', $event.target.value)" :placeholder="placeholder"
      :type="type" :min="parseInt(min)" :style="readonly? `color: ${textcolor}; cursor: default`:`color: ${textcolor}`" :maxlength="maxlength">
      </v-layout>
    </v-card>
</template>

<script>
export default {
  props: ['icon', 'value', 'placeholder', 'color', 'readonly', 'textarea', 'type', 'min', 'maxlength', 'textcolor'],
  methods: {
  }
}
</script>

<style lang="css" scoped>
  .work_package-data-field {
    color: black;
    width: 100%;
    font-size: 20px;
    /* border-bottom: solid;
    border-width: 1px; */
    /* background-color: white;
    opacity: 0.25; */
  }
  .work_package-data-field::placeholder {
    color: white;
    font-style: italic;
    /* background-color: white;
    opacity: 0.25; */
  }
  .dataFieldIcon {
    zoom: 1.2;
  }

  .work_package-data-field:focus {
       width: 100%;
       outline: none;
  }
</style>
